<template>
  <div class="flex items-center lg:gap-[0.571rem] flex-wrap gap-[0.3571429rem]">
    <SocialShareButton
      v-for="btn in buttons"
      :key="btn.network"
      :network="btn.network"
      :url="url ?? undefined"
      :title="btn.title ?? title"
      :description="btn.description ?? description"
      :videoId="btn.videoId ?? videoId"
      :ariaLabel="btn.ariaLabel"
      :id="`${btn.network}-button`"
    >
      <Icon :icon="btn.icon" class="text-white text-[1rem]" />
      <span class="font-normal">{{ btn.label }}</span>
    </SocialShareButton>
  </div>
</template>

<script setup lang="ts">
import SocialShareButton from '../atom/SocialShareButton.vue'
import Icon from '../atom/icon.vue'
import type { ShareNetwork } from '~~/shared/utils/share.config'

interface Props {
  url?: string | null
  title?: string | null
  description?: string | null
  videoId?: string | null 
}
const props = defineProps<Props>()

interface ButtonConfig {
  network: ShareNetwork
  icon: string
  label: string
  title?: string | null
  description?: string | null
  videoId?: string | null
  ariaLabel?: string | null
}

const buttons: ButtonConfig[] = [
  {
    network: 'facebook',
    icon: 'facebook',
    label: 'Share',
    videoId: null,
    title: null,
    description: null,
    ariaLabel: 'Share this video on facebook'
  },
  {
    network: 'twitter',
    icon: 'twitter',
    label: 'Tweet',
    videoId: null,
    title: null,
    description: null,
    ariaLabel: 'Share this video on Twitter'
  },
  {
    network: 'copy',
    icon: 'link',
    label: 'Copy',
    videoId: null,
    title: null,
    description: null,
    ariaLabel: 'Copy'
  },
  {
    network: 'youtubeWatch',
    icon: 'universal-access',
    label: 'Audio Description',
    videoId: null,
    title: null,
    description: null,
    ariaLabel: 'Audio description'
  }
] as const
</script>
 